<template>
  <section :key="imagePng" class="ImageWrapper">
    <picture>
      <source type="image/webp" :srcset="imageWebp" />
      <img
        alt="A Qwello charging pole that is viewed through the front window of a car"
        class="PoleImage"
        :src="imagePng"
      />
    </picture>
  </section>
</template>

<script>
export default {
  props: ['imageWebp', 'imagePng'],
};
</script>

<style scoped>
.ImageWrapper {
  grid-column: 1;
  grid-row: 3;
  width: 55%;
  /* height: 350px; */
  justify-self: flex-end;
  /* max-width: 210px; */
}

.PoleImage {
  display: block;
  width: 100% !important;
  object-fit: cover;
  height: 100%;
}

@media (min-width: 768px) {
  .ImageWrapper {
    grid-column: 2;
    grid-row: 1 / -1;
    width: 100%;
  }
  .PoleImage {
    display: block;
    height: auto;
    width: auto;
  }
}
@media (min-width: 1800px) {
  .ImageWrapper {
    width: 100%;
  }
}
</style>
